import React, { useEffect, useState } from 'react'
import { Dropdown, DropdownContent, DropdownToggle } from '@mc/design-system'
import { Experiment } from '@mc/experiments-react'
import { useBreakpoint } from '@mc/media'
import { GIFTING_ON_MOBILE_NAV_FLAG_NAME } from '../../constants'
import { useBadgeVisibility } from '../../hooks/useBadgeVisibility'
import { useGiftingOnMobileNav } from '../../hooks/useGiftingOnMobileNav'
// Copied from @mc/navigation/src/assets/hamburgerIcon.svg
import HamburgerIcon from '../assets/hamburgerIcon.svg'
// Copied from @mc/navigation/src/Menu.module.scss but just the menu class
import baseClasses from './MenuBase.module.scss'

type MenuProps = {
  ariaLabel?: string
  label?: string
  className?: string
  children?: React.ReactNode
  onToggle?: () => void
}

const MenuVariant = ({
  ariaLabel,
  label,
  className,
  children,
  onToggle,
}: MenuProps) => {
  const { showBadge, dismissBadge } = useBadgeVisibility()

  const handleClick = () => {
    dismissBadge()
    onToggle?.()
  }

  return (
    <Dropdown placement='bottom-end' fixed>
      <DropdownToggle>
        <button
          aria-label={ariaLabel}
          className={`mc-clickable mc-py-2 ${className}`}
          style={{
            transition: 'opacity 200ms ease',
            background: 'none',
            color: 'inherit',
          }}
          onClick={handleClick}
        >
          <div className='d-flex align-items-center position-relative'>
            {label && (
              <h6 className='mc-text-h6 mc-text--capitalize mc-pr-1 d-none d-lg-block'>
                {label}
              </h6>
            )}
            <HamburgerIcon className='mc-icon mc-icon--3' />
            {showBadge && (
              <div
                className='mc-bg-primary mc-corners--circle position-absolute'
                style={{
                  width: 8,
                  height: 8,
                  top: -4,
                  right: -4,
                }}
              />
            )}
          </div>
        </button>
      </DropdownToggle>
      <DropdownContent appendToBody={false} className={baseClasses.menu}>
        {children}
      </DropdownContent>
    </Dropdown>
  )
}

interface MenuExperimentProps extends MenuProps {
  Control: React.ReactNode
}

export const MenuWrapper = ({ Control, ...props }: MenuExperimentProps) => {
  const isGiftingOnMobileNav = useGiftingOnMobileNav()
  const { isSm } = useBreakpoint()
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isGiftingOnMobileNav || !isClient || !isSm) {
    return Control
  }

  return (
    <Experiment
      name={GIFTING_ON_MOBILE_NAV_FLAG_NAME}
      default={() => Control}
      variant_1={() => <MenuVariant {...props} />}
    />
  )
}
